<button mat-button class="btn_yellow animation_auction btn-11"
  (click)="openPopupSuperBid()"
  *ngIf="current_bid < super_bid_value"
>
  <div class="dot"></div>
  Super Lance
</button>

<div id="canvas"></div>
